import { createSlice } from "@reduxjs/toolkit";

export const pageDataSlice = createSlice({
  name: "pageData",
  initialState: {
    serviceList: {},
    partnerList: {},
    onePartner: {},
    partnerId: null,
    isloading: false,
    comments: [],
  },
  reducers: {
    setServiceList: (state, action) => {
      state.serviceList = action.payload;
    },
    setPartnerList: (state, action) => {
      state.partnerList = action.payload;
    },
    setPartnerID: (state, action) => {
      state.partnerId = action.payload;
    },
    setLoading: (state, action) => {
      state.isloading = action.payload;
    },
    setOnePartnerData: (state, action) => {
      state.onePartner = action.payload;
    },
    setPartnerComments: (state, action) => {
      state.comments = action.payload;
    },
  },
});

export const {
  setServiceList,
  setPartnerList,
  setPartnerID,
  setLoading,
  setOnePartnerData,
  setPartnerComments,
} = pageDataSlice.actions;

export const selectServiceList = (state) => state.pageData.serviceList;
export const selectPartnerList = (state) => state.pageData.partnerList;
export const selectPartnerId = (state) => state.pageData.partnerId;
export const selectIsLoading = (state) => state.pageData.isloading;
export const selectOnePartner = (state) => state.pageData.onePartner;
export const selectOnePartnerComments = (state) => state.pageData.comments;

export default pageDataSlice.reducer;
